import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthTenantService {

  baseUrl: string = `${environment.authUrl}/tenant`;

  constructor(private http: HttpClient) { }

  getTenantOptions(): Observable<any> {
    return this.http.get(this.baseUrl);
  }

}
